// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__erXRS","menu":"PrivacyPolicy_menu__W6I14"};